import React from "react";
import { useNavigate } from 'react-router-dom';
import styles from "./ConditionsUtilisationPage.module.scss"; // Asegúrese de tener un archivo SCSS correspondiente

import Footer from '../../components/Footer/Footer';

const ConditionsUtilisationPage_Es = () => {

  const navigate = useNavigate();

  return (
    <>
      <div className={styles.container}>
        <div className={styles.content}>
            <h1>Condiciones de uso del servicio</h1>

            <hr />
            <section>
            <h2>1. Presentación del servicio</h2>
            <p>
                La aplicación <strong>Hatann'App</strong> es una plataforma interactiva de juego de pistas que permite a los usuarios
                responder preguntas según su progreso en una ruta predefinida.
                El uso de la aplicación implica la aceptación plena y total de las presentes condiciones generales de uso.
            </p>
            </section>

            <section>
            <h2>2. Acceso al servicio</h2>
            <p>
                La aplicación <strong>Hatann'App</strong> es accesible a través de un navegador web en un teléfono inteligente o cualquier otro dispositivo compatible.
                El acceso puede estar limitado en caso de pérdida de conexión, pero la aplicación está diseñada para garantizar una experiencia óptima incluso en modo fuera de línea.
            </p>
            </section>

            <section>
            <h2>3. Creación de una cuenta</h2>
            <p>
                Algunas funciones de <strong>Hatann'App</strong> pueden requerir la creación de una cuenta de usuario.
                Al registrarse, el usuario se compromete a proporcionar información precisa y a mantener la confidencialidad de sus credenciales.
            </p>
            </section>

            <section>
            <h2>4. Uso del servicio</h2>
            <p>El usuario se compromete a:</p>
            <ul>
                <li>No utilizar <strong>Hatann'App</strong> con fines fraudulentos o ilegales.</li>
                <li>No interrumpir el correcto funcionamiento del servicio.</li>
                <li>Respetar a los demás participantes del juego de pistas.</li>
            </ul>
            </section>

            <section>
            <h2>5. Propiedad intelectual</h2>
            <p>
                Todos los elementos de la aplicación <strong>Hatann'App</strong>, incluidos el contenido, las imágenes y el código, están protegidos por las leyes de propiedad intelectual
                y no pueden ser reproducidos, modificados o distribuidos sin autorización previa.
            </p>
            </section>

            <section>
            <h2>6. Protección de datos personales</h2>
            <p>
                <strong>Hatann'App</strong> recopila ciertos datos para mejorar la experiencia del usuario. Estos datos se procesan
                de acuerdo con nuestra <a className={styles.link} onClick={() => navigate("/privacy")} rel="noopener noreferrer">política de privacidad</a>.
            </p>
            </section>

            <section>
            <h2>7. Responsabilidad</h2>
            <p>
                El editor de <strong>Hatann'App</strong> no será responsable en caso de:
            </p>
            <ul>
                <li>Uso inadecuado del servicio por parte del usuario.</li>
                <li>Problemas técnicos fuera de nuestro control (fallo del servidor, pérdida de conexión, etc.).</li>
                <li>Contenido generado por los propios usuarios.</li>
            </ul>
            </section>

            <section>
            <h2>8. Modificación de las condiciones</h2>
            <p>
                El editor se reserva el derecho de modificar estas condiciones de uso en cualquier momento.
                Los usuarios serán informados de las actualizaciones a través de <strong>Hatann'App</strong>.
            </p>
            </section>

            <section>
            <h2>9. Contacto</h2>
            <p>
                Para cualquier pregunta relacionada con estas condiciones, puede contactarnos en la siguiente dirección:&nbsp; 
                <a className={styles.link} href="mailto:contact@hatanna-editions.fr">contact@hatanna-editions.fr</a>
            </p>
            </section>

            <section>
            <h2>10. Desarrollo</h2>
            <p>
                Esta aplicación ha sido desarrollada por <strong>Scriptales SAS</strong> (<a className={styles.link} href="https://scriptales.fr" target="_blank" rel="noopener noreferrer">scriptales.fr</a>).
            </p>
            </section>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default ConditionsUtilisationPage_Es;
